// src/components/Header.js
import React, { useState, useEffect } from "react";
import { NavLink , useLocation , Link} from "react-router-dom";
import "./Header.css";
import {
  FaFacebookF, FaTwitter, FaInstagram, FaYoutube,
  FaDownload, FaBars, FaPhoneAlt, FaEnvelope, FaHome
} from "react-icons/fa";
import Headerimage1 from "../Assets/headerbanner.png";
import Headerimage2 from "../Assets/headerbannermobile.png";
import { useTranslation } from "react-i18next";

// Import ContactModal
import ContactModal from "./ContactModal";

const Header = () => {
  const { t, i18n } = useTranslation();

  const location = useLocation(); // ✅ INSIDE component

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ✅ Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Restore language from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("i18nextLng");
    if (saved && saved !== i18n.language) i18n.changeLanguage(saved);
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  // STICKY behavior
  useEffect(() => {
    const menu = document.querySelector(".cmpr-header-menu-bg");
    if (!menu) return;
    const initialOffsetTop = menu.offsetTop;

    const handleScroll = () => {
      if (window.innerWidth > 1024) {
        if (window.scrollY >= initialOffsetTop) setIsSticky(true);
        else setIsSticky(false);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <header className="cmpr-header-wrapper">
      <div className="cmpr-header-topbar">
        <div className="cmpr-topbar-content">
          <div className="cmpr-topbar-left">
            <a href="tel:+919944662747" className="cmpr-topbar-item">
              <FaPhoneAlt /> +91 99446 62747
            </a>
            <a href="mailto:info@cmpranesh-admk.com" className="cmpr-topbar-item">
              <FaEnvelope /> info@cmpranesh-admk.com
            </a>
            <div className="cmpr-topbar-social">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaYoutube /></a>
            </div>
          </div>

          <div className="cmpr-topbar-right">
            {/* <a href="/brochure.pdf" download className="cmpr-topbar-brochure-btn">
              <FaDownload /> Brochure
            </a> */}

            {/* Desktop language dropdown */}
            <div className="cmpr-topbar-lang language-dropdown desktop-only">
              <button className="lang-btn">
                <img
                  src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg"
                  alt="Indian Flag" style={{ width: 20, height: 14, marginRight: 8 }}
                />
                {t("language")} ▼
              </button>

              <div className="lang-menu">
                <button onClick={() => changeLanguage("en")}>English (IN)</button>
                <button onClick={() => changeLanguage("ta")}>தமிழ்</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cmpr-header-main">
        <img src={Headerimage1} className="cmpr-header-full-img desktop-img" alt="Header Banner" draggable="false" onContextMenu={(e)=>e.preventDefault()} />
        <img src={Headerimage2} className="cmpr-header-full-img mobile-img" alt="Header Banner Mobile" draggable="false" onContextMenu={(e)=>e.preventDefault()} />
      </div>

      <div className={`cmpr-header-menu-bg ${isSticky ? "sticky" : ""}`}>
        <nav className="cmpr-header-menu">
          <ul className={`cmpr-menu-list ${mobileMenuOpen ? "show-menu" : ""}`}>
            <li className="cmpr-menu-item">
              <Link to="/"><FaHome /> {t("home")}</Link>
            </li>
            <li className="cmpr-menu-item"><NavLink to="/Leaders">{t("history")}</NavLink></li>
            <li className="cmpr-menu-item"><NavLink to="/about-cmpranesh">{t("leader")}</NavLink></li>
            <li className="cmpr-menu-item"><NavLink to="/Gallery">{t("gallerys")}</NavLink></li>
            <li className="cmpr-menu-item"><NavLink to="/organisationteam">{t("team")}</NavLink></li>
            <li className="cmpr-menu-item"><NavLink to="/event">{t("event")}</NavLink></li>
            <li className="cmpr-menu-item"><NavLink to="/news">{t("news")}</NavLink></li>

            <li className="cmpr-menu-item mobile-only cmpr-mobile-btn-wrap">
              <button className="cmpr-menu-btn red-btn" onClick={() => setIsModalOpen(true)}>
                {t("complaint")}
              </button>
              <button className="cmpr-menu-btn black-btn">
                <Link to="/membership">{t("member")}</Link>
              </button>
            </li>
          </ul>

          <div className="cmpr-header-menu-buttons desktop-only">
            <button className="cmpr-menu-btn red-btn" onClick={() => setIsModalOpen(true)}>
              {t("complaint")}
            </button>
            <button className="cmpr-menu-btn black-btn">
              <Link to="/membership">{t("member")}</Link>
            </button>
          </div>

          <div className="cmpr-mobile-menu-icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <FaBars />
          </div>

          <div
            className="cmpr-mobile-lang-btn"
            onClick={() => changeLanguage(i18n.language === "ta" ? "en" : "ta")}
            style={{ cursor: "pointer" }}
          >
            {i18n.language === "ta" ? "தமிழ் / ENG" : "ENG / தமிழ்"}
          </div>
        </nav>
      </div>

      {/* Contact Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
};

export default Header;
